<template>
  <div>
    <!-- <div class="position-relative" style="position: fixed; width: 84%"> -->
    <div v-if="!initialResponseReceived" class="spiner__container">
      <b-spinner variant="primary" type="grow"></b-spinner>
    </div>
    <div class="" v-else>
      <div class="header sticky-top">
        <UserDetailHeader :userDetails="userDetailsData" @updateTag="updateTag($event)" @updateRate="updateRate($event)" @updateAdminNote="updateAdminNote($event)" />
      </div>
      <div class="tabs">
        <b-nav tabs>
          <b-nav-item to="?navLink=SupplementaryInfo" :active="$route.query.navLink === 'SupplementaryInfo'"> اطلاعات تکمیلی </b-nav-item>
          <b-nav-item v-for="newTab in tab" :key="newTab" :to="navLink(newTab)" :active="$route.query.navLink === activeTab">
            <div class="d-flex align-items-center">
              <span style="display: block; margin: 0 10px">{{ addTitleToTabHeader(newTab) }}</span>
              <i
                class="fa fa-times"
                @click="
                  changeRouter()
                  removeSelectedTab(newTab)
                "
              ></i>
            </div>
          </b-nav-item>
        </b-nav>
        <div class="tab-content">
          <div v-if="hasUserGalance">
            <div v-if="$route.query.navLink === 'UserGalance'" class="p-2">
              <b-row>
                <b-col cols="12" md="12" lg="12" xl="7" class="pr__zero">
                  <!-- <div style="width: 100%; height: 394px; background: white; border-radius: 6px">
                    <div style="padding-right: 15px; padding-top: 15px; font-size: 16px">
                      <div>لیست سفارش ها</div>
                    </div>
                    <div class="empty-table">
                      <img src="@/assets/images/exclamation.svg" class="me-2" />
                      <div class="empty-table-text">موردی ثبت نشده است</div>
                    </div>
                  </div> -->
                  <Table hover striped :clickToChangeRoute="false" :selectOption="true" selectRoute="user/detail?navlink=" heightStyle="height: 502px;overflow: auto" tableId="1" />
                  <!-- <template v-slot:TableHeader> <TableHeader contextVisible titleVisible title="لیست دریافتی ها و پرداختی ها"></TableHeader></template>
                  </Table> -->
                </b-col>
              </b-row>
            </div>
          </div>
          <div v-if="$route.query.navLink === 'SupplementaryInfo'" class="p-2">
            <UserFullInformation
              v-if="accessToUserDetail"
              :key="UserFullInformationKey"
              :dataTables="dataTables"
              :isUserDetail="isUserDetail"
              @userUpdated="userUpdatedFlag = $event"
              :wannaUpdate="wannaUpdate"
              :errorToast="errorToast"
            />
            <Loader v-else :loading="loading" />
          </div>
          <div v-for="newTab in tab" :key="newTab" :title="addTitleToTabHeader(newTab)">
            <div class="p-2" v-if="$route.query.navLink === newTab">
              <UserTeamTask />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UserFullInformation from './UserFullInformation'
import Table from '../../common/table/simpleTable/index.vue'
import UserDetailHeader from './UserDetailHeader'
import UserTeamTask from '../../teamtask/index.vue'
import { userMixins, userTeamMixins } from '../../../utils/mixins'
import userDataProvider from '../../../services/user'
import IdpDataProvider from '../../../services/idp'
import Loader from '../../common/loader.vue'

export default {
  name: 'user-profile',
  components: {
    UserFullInformation,
    Table,
    UserDetailHeader,
    UserTeamTask,
    Loader,
  },
  mixins: [userTeamMixins, userMixins],
  props: {
    isUserDetail: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      UserFullInformationKey: 1,
      accessToUserDetail: false,
      initialResponseReceived: false,
      userUpdatedFlag: false,
      title: 'جدول تیم تسک',
      hasUserGalance: false,
      headerItems: [
        {
          text: 'داشبورد',
          href: '/',
        },
        {
          text: 'جدول تیم تسک',
          active: true,
        },
      ],
      userDetailsData: {},
      dataTables: {},
      forceUpdateFlag: false,
      wannaUpdate: false,
      loading: null,
      errorToast: false,
    }
  },
  computed: {
    routeQuery() {
      return this.$route.query.navLink
    },
    routerValue() {
      return this.$route.params.id
    },
  },
  methods: {
    // getUserOrders(payload) {
    //   userDataProvider
    //     .getUserList(payload)
    //     .then((res) => {
    //       this.userOrdersData = res.data
    //     })
    //     .catch((err) => {
    //       console.log(err)
    //     })
    // },
    // callLogLoadMoreData() {
    //   if (this.hasMoreCallLog) {
    //     this.chatBoxDataPagenumber += 1
    //     let temp = {
    //       peopleId: this.routerValue,
    //       pageNumber: this.chatBoxDataPagenumber,
    //     }
    //     this.getCallLog(temp)
    //   }
    // },
    // tableObj(e) {
    //   this.wannaUpdate = false
    //   const apiUrl = this.userProfileMenuItems.find((item) => item.key == e.tableId).url
    //   userDataProvider
    //     .getUserProfileItemsData(apiUrl, { peopleId: this.routerValue, searchDto: { pageNumber: e.page, pageSize: e.pageSize.count, filters: e.filters, search: e.query } })
    //     .then((res) => {
    //       this.dataTables[e.tableId] = res.data
    //       this.wannaUpdate = true
    //     })
    // },
    addTitleToTabHeader(payload) {
      return 'شناسه یکتا ' + payload
    },
    navLink(payload) {
      return '?navLink=' + payload
    },
    changeRouter() {
      setTimeout(() => {
        const path = this.$route.path
        // this.$router.push({ path: `${path}?navLink=${items[0].id}` })
        this.$router.push({ path: `${path}?navLink=UserGalance` })
      }, 50)
    },
    removeSelectedTab(payload) {
      return this.removeTab({
        indexToRemove: payload,
      })
    },
    updateTag(e) {
      if (e.tagId) {
        userDataProvider.removeTag({ peopleId: e.userId, tagId: e.tagId }).then((res) => {
          this.getUserDetailsData()
        })
      } else {
        userDataProvider.addTag({ peopleId: e.userId, title: e.title }).then((res) => {
          this.getUserDetailsData()
        })
      }
    },
    updateRate(e) {
      userDataProvider.updateRate({ peopleId: this.$route.params.id, satisfactionRate: e })
    },
    updateAdminNote(e) {
      userDataProvider.updateAdminNote({ peopleId: this.$route.params.id, adminNote: e }).then((res) => {
        this.getUserDetailsData()
        this.UserFullInformationKey += 1
      })
    },
    async getUserDetailsData() {
      userDataProvider
        .getUserDetails({
          peopleId: this.$route.params.id,
        })
        .then((res) => {
          this.$store.dispatch('user/setUserDetails', res.data.data)
          this.userDetailsData = this.userDetails.peopleGlobalDto
        })
    },
    flushBeforeDestroy() {
      return this.flushTeamTasks({
        payload: [],
      })
    },
    async getUserDetailHeaderData() {
      userDataProvider
        .getUserDetails({
          peopleId: this.$route.params.id,
        })
        .then((res) => {
          this.$store.dispatch('user/setUserDetails', res.data.data)
          this.userDetailsData = this.userDetails.peopleGlobalDto
          this.forceUpdateFlag = true
          this.errorToast = res.data.data.peopleGlobalDto.isDeactivate
        })
      this.userUpdatedFlag = false
      this.UserFullInformationKey += 1
    },
    // getCallLog(data) {
    //   crmDataProvider
    //     .voiceCallLog(data)
    //     .then((res) => {
    //       if (res.data.data.length === 0) {
    //         this.hasMoreCallLog = false
    //         return
    //       }
    //       this.chatBoxData.push(...res.data.data)
    //       this.chatBoxDataPagination = res.data.pagination
    //       let tempChatBoxData = this.chatBoxData.map((data) => data.callLogs)
    //       let tempChatBoxData2 = []
    //       for (let i = 0; i < tempChatBoxData.length; i++) {
    //         for (let j = 0; j < tempChatBoxData[i].length; j++) {
    //           tempChatBoxData2.push(tempChatBoxData[i][j])
    //         }
    //       }
    //       if (this.chatBoxDataPagenumber === 1 && tempChatBoxData2.length < 5) {
    //         this.chatBoxDataPagenumber += 1
    //         let temp = {
    //           peopleId: this.routerValue,
    //           pageNumber: this.chatBoxDataPagenumber,
    //         }
    //         this.getCallLog(temp)
    //       }
    //     })
    //     .catch((err) => {})
    // },
    // getChartsData() {
    //   crmDataProvider
    //     .linearReport()
    //     .then((res) => {
    //       this.chartData = res.data
    //     })
    //     .catch((err) => {
    //       this.chartData = [
    //         {
    //           chartHeader: 'تعداد درخواست های تماس',
    //           chartDetail: '2213',
    //           series: [
    //             {
    //               name: '',
    //               data: [1, 10, 1, 1, 10, 1, 1, 2, 3, 4, 5, 20, 30, 10, 7, 7, 6, 6, 6, 6, 4, 2, 1],
    //             },
    //           ],
    //           chartOptions: {
    //             chart: {
    //               type: 'area',
    //               height: 30,
    //               width: 100,
    //               sparkline: {
    //                 enabled: true,
    //               },
    //             },
    //             stroke: {
    //               curve: 'smooth',
    //               width: 2,
    //             },
    //             colors: ['#50a5f1'],
    //             fill: {
    //               type: 'gradient',
    //               gradient: {
    //                 shadeIntensity: 1,
    //                 inverseColors: false,
    //                 opacityFrom: 0.45,
    //                 opacityTo: 0.05,
    //                 stops: [25, 100, 100, 100],
    //               },
    //             },
    //             tooltip: {
    //               fixed: {
    //                 enabled: false,
    //               },
    //               x: {
    //                 show: false,
    //               },
    //               marker: {
    //                 show: false,
    //               },
    //             },
    //           },
    //           isrtl: 'rtl',
    //         },
    //         {
    //           chartHeader: 'تعداد درخواست های تماس',
    //           chartDetail: '2213',
    //           series: [
    //             {
    //               name: '',
    //               data: [1, 10, 1, 1, 10, 1, 1, 2, 3, 4, 5, 20, 30, 10, 7, 7, 6, 6, 6, 6, 4, 2, 1],
    //             },
    //           ],
    //           chartOptions: {
    //             chart: {
    //               type: 'area',
    //               height: 30,
    //               width: 100,
    //               sparkline: {
    //                 enabled: true,
    //               },
    //             },
    //             stroke: {
    //               curve: 'smooth',
    //               width: 2,
    //             },
    //             colors: ['#50a5f1'],
    //             fill: {
    //               type: 'gradient',
    //               gradient: {
    //                 shadeIntensity: 1,
    //                 inverseColors: false,
    //                 opacityFrom: 0.45,
    //                 opacityTo: 0.05,
    //                 stops: [25, 100, 100, 100],
    //               },
    //             },
    //             tooltip: {
    //               fixed: {
    //                 enabled: false,
    //               },
    //               x: {
    //                 show: false,
    //               },
    //               marker: {
    //                 show: false,
    //               },
    //             },
    //           },
    //           isrtl: 'rtl',
    //         },
    //       ]
    //     })
    // },
  },
  watch: {
    userUpdatedFlag(val) {
      if (val === true) {
        this.getUserDetailHeaderData()
      }
    },
    routeQuery(val) {
      if (!val) {
        // this.$router.push({
        //   path: '/list/user',
        // })
        this.$router.go(-1)
      }
    },
    routerValue(val) {
      this.getUserDetailHeaderData()
    },
  },
  async mounted() {
    IdpDataProvider.getPagePermisions({ path: '/list/user/detail' }).then((res) => {
      this.hasUserGalance = res.data.data.permission.isAccessFurtherInformation

      this.initialResponseReceived = true
      this.flushBeforeDestroy()
      this.accessToUserDetail = false

      this.getUserDetailHeaderData()

      // this.getCallLog({ peopleId: this.routerValue, pageNumber: this.chatBoxDataPagination })

      this.loading = true
      userDataProvider.getUserProfileMenuItems().then((res) => {
        this.setUserProfileMenuItems(res.data.data)
        for (let i = 0; i < this.userProfileMenuItems.length; i++) {
          userDataProvider
            .getUserProfileItemsData(this.userProfileMenuItems[i].url, {
              peopleId: this.$route.params.id,
              searchDto: {
                key: 'Ordering-2',
                query: '',
                pageSize: 10,
                pageNumber: 1,
                sortBy: '',
                isSortAsc: true,
                fieldSearchs: [
                  {
                    fieldName: '',
                    type: '',
                    text: '',
                    startDate: '2022-01-11T13:02:10.671Z',
                    endDate: '2022-01-11T13:02:10.671Z',
                    min: 0,
                    max: 0,
                    opration: '',
                    options: [0],
                  },
                ],
              },
            })
            .then((res) => {
              this.dataTables[this.userProfileMenuItems[i].key] = res.data
            })
            .then((r) => {
              if (i === this.userProfileMenuItems.length - 1) {
                if (res.status === 200 && res.data) {
                  this.$nextTick(() => {
                    this.loading = null
                    this.userProfileMenuItems[0].key === 'user' ? (this.accessToUserDetail = true) : null
                    this.UserFullInformationKey += 1
                  })
                }
              }
            })
            .catch((err) => {
              this.dataTables[i] = []
            })
        }
      })
      // this.getChartsData()
      if (this.hasUserGalance) {
        this.$router.push({ path: `${this.$route.path}?navLink=SupplementaryInfo` })
        // this.$router.push({ path: `${this.$route.path}?navLink=UserGalance` })
      } else {
        this.$router.push({ path: `${this.$route.path}?navLink=SupplementaryInfo` })
      }
    })
    // .then(() => {
    //   this.getUserOrders({
    //     peopleId: this.routerValue,
    //     searchDto: {
    //       key: 'Ordering-2',
    //       query: '',
    //       pageSize: 10,
    //       pageNumber: 1,
    //       sortBy: '',
    //       isSortAsc: true,
    //       fieldSearchs: [
    //         {
    //           fieldName: '',
    //           type: '',
    //           text: '',
    //           startDate: '2022-01-11T13:02:10.671Z',
    //           endDate: '2022-01-11T13:02:10.671Z',
    //           min: 0,
    //           max: 0,
    //           opration: '',
    //           options: [0],
    //         },
    //       ],
    //     },
    //   })
    // })
  },
}
</script>

<style scoped>
::v-deep .main-row-mt {
  margin: 0px 0 0 0 !important;
}
::v-deep .team-task-detail-status-bar {
  margin-top: -30px;
  top: unset !important;
}
.header {
  background-color: white;
  width: 100%;
  height: 120px;
  z-index: 2 !important;
}
::v-deep .links-menu {
  height: fit-content;
}
::v-deep .nav-tabs {
  background-color: white;
  margin-top: 20px;
  border: none;
  margin-bottom: 10px;
}
::v-deep .nav-link {
  border: none;
  padding: 10px 18px;
}
::v-deep .router-link-exact-active {
  color: #556ee6 !important;
  border-bottom: 2px solid #556ee6 !important;
}
.apexcharts-datalabels-group text {
  font-size: 13px;
}
.row-min-height {
  /* height: 502px; */
}

.pr__zero {
  padding-right: 0 !important;
}
.pl__zero {
  padding-left: 0 !important;
}
::v-deep .page-content {
  padding: 94px 0 0 0 !important;
}

::v-deep .tab-content {
  height: calc(100vh - 281px);
  overflow: scroll;
}
::-webkit-scrollbar {
  display: none;
}
.spiner__container {
  height: calc(100vh - 120px);
  display: flex;
  align-items: center;
  justify-content: center;
}
.empty-table {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  margin-top: 70px;
  background-color: white;
  flex-direction: column;
}
.empty-table-text {
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 26px;
  letter-spacing: 0px;
}
::v-deep .semi .chartRow {
  position: relative;
  bottom: 35px;
  height: 90px;
  overflow: hidden;
}
::v-deep .headere {
  width: 100% !important;
  height: 80px !important;
  z-index: 51 !important;
  background-color: #f8f8fb !important;
}
</style>
